/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fond_Green_Eel_PantInputs */

const en_fond_green_eel_pant = /** @type {(inputs: Fond_Green_Eel_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter address...`)
};

const de_fond_green_eel_pant = /** @type {(inputs: Fond_Green_Eel_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse eingeben...`)
};

/**
* | output |
* | --- |
* | "Enter address..." |
*
* @param {Fond_Green_Eel_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fond_green_eel_pant = /** @type {((inputs?: Fond_Green_Eel_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fond_Green_Eel_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fond_green_eel_pant(inputs)
	return de_fond_green_eel_pant(inputs)
});